module.exports = __webpack_public_path__ + "img/orbit.2f54b0a0.svg";